/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ConfirmAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function ConfirmAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Treatment/Content/Actions/Content/StartContract/Content/Main/Content/ConfirmAction",
  onSubmit,
  isSubmitting
  
}) {
let startContractSubmitData = fromData.useDataSubmit({ viewPath,
context: 'start_contract',
})
let startContractIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'start_contract',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 data="start_contract"
 onClick={startContractSubmitData}
 disabled={startContractIsSubmittingData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Start"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}